import React from "react";
import {
    EuiTitle,
    EuiText,
    EuiPanel,
    EuiPageBody,
    EuiPageHeader,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPageContentHeaderSection,
    EuiPageContentBody,
    EuiPage,
} from "@elastic/eui";
import useWindowDimensions from "../../hooks/useWindowDimensions";

// you will need to install via 'npm install jsonwebtoken' or in your package.json

const jwt = require("jsonwebtoken");

const METABASE_SITE_URL = "http://data.illa.com.eg";
const METABASE_SECRET_KEY = "c652c2d3ac149a0e56227be41683e734af0c3990217368d6a675021ed70832ef";

const payload = {
    resource: { dashboard: 65 },
    params: {},
    exp: Math.round(Date.now() / 1000) + 10 * 60, // 10 minute expiration
};
const token = jwt.sign(payload, METABASE_SECRET_KEY);

const iframeUrl = `${METABASE_SITE_URL}/embed/dashboard/${token}#theme=night&bordered=false&titled=true`;

export default function SupplierReporting() {
    const { windowWidth, windowHeight } = useWindowDimensions();
    return (
        <div>
            <EuiPage>
                <EuiPageBody component="div">
                    <EuiPageHeader pageTitle="Page title" />
                    <EuiPageContent>
                        <EuiPageContentHeader>
                            <EuiPageContentHeaderSection>
                                <EuiTitle>
                                    <h2>Content title</h2>
                                </EuiTitle>
                            </EuiPageContentHeaderSection>
                        </EuiPageContentHeader>
                        <EuiPageContentBody>Content body</EuiPageContentBody>
                    </EuiPageContent>
                </EuiPageBody>
            </EuiPage>
        </div>
    );
}
